import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { LIMIT } from '@/constants'
import { fetchItems } from '@/api/transactions'
import {
  ITransaction,
  ITransactionsFilter,
  ITransactionsPayload
} from '@/interfaces/transactions'
import useCrudStore from '@/hooks/useCrudStore'
const defaultFilter: ITransactionsFilter = {
  created_at_gteq: '',
  created_at_lteq: ''
}
export const useTransactionsStore = defineStore('transactions', () => {
  // State
  const items = ref<{ [itemId: string]: ITransaction }>({})
  const total = ref<{ [typeId: number]: number }>({})
  const sum = ref<{ [typeId: number]: number }>({})
  const currentItems = ref<{ [typeId: number]: Array<ITransaction> }>({})
  const filter = ref<ITransactionsFilter>({ ...defaultFilter })
  const limit = ref(LIMIT)
  const start = ref(0)
  const sortField = ref('id')
  const sortDirection = ref('desc')
  const currentPage = ref(1)
  const listLoading = ref(false)
  const { FetchItemsVariant } = useCrudStore({ defaultFilter, fetchItems })

  const FetchItems = async (
    currentPayload: ITransactionsPayload = payload.value
  ) => {
    listLoading.value = true
    const typeId = currentPayload.filter.type_id as number
    const response = await fetchItems(currentPayload)
    setItems(response.data)
    setCurrentItems(typeId, response.data)
    setTotal(typeId, response.meta.total)
    setSum(typeId, Number(response.meta.sum))
    listLoading.value = false
  }

  const SetFilters = (newFilter: ITransactionsFilter) => {
    filter.value = { ...newFilter }
  }

  const SetCurrentPage = (page: number) => {
    currentPage.value = page
  }

  const SetLimit = (newLimit: number) => {
    limit.value = newLimit
  }

  const setItems = (data: ITransaction[]) => {
    items.value = data.reduce(
      (acc: { [key: string]: ITransaction }, item: ITransaction) => {
        acc[item.id] = item
        return acc
      },
      {}
    )
  }

  const setCurrentItems = (typeId: number, items: ITransaction[]) => {
    currentItems.value[typeId] = items
  }

  const setTotal = (typeId: number, totalCount: number) => {
    total.value[typeId] = totalCount
  }

  const setSum = (typeId: number, totalSum: number) => {
    sum.value[typeId] = totalSum
  }

  const payload = computed(() => ({
    limit: limit.value,
    start: (currentPage.value - 1) * limit.value,
    sorter: {
      field: sortField.value,
      direction: sortDirection.value
    },
    filter: filter.value
  }))

  // Getters
  const getItemsByType = computed(
    () => (typeId: number) => currentItems.value[typeId] || []
  )

  return {
    // State
    items,
    currentItems,
    total,
    sum,
    listLoading,

    // Actions
    FetchItems,
    SetFilters,
    SetCurrentPage,
    SetLimit,
    FetchItemsVariant,

    // Getters
    getItemsByType
  }
})
